export const GAME_VERSION = '1.0.6';

export function getState() {
	// previous feature names / dont reuse!:
	// multiplayer
	const newState = { 
		version: GAME_VERSION,
		features: {},
		debug: false,
		numberOfPlayers: 1,
		singleplayer: {scores: []},
		multiplayerCoop: {scores: []},
		multiplayerVs: {scores: []},
	}
	const current = localStorage.getItem('jumpnrun');
	return current ? JSON.parse(current) : newState;
}

function manipulateState(manipulationFunction) {
	let s = getState();
	manipulationFunction(s)
	localStorage.setItem('jumpnrun', JSON.stringify(s));
}
export function numberOfPlayers() {
	return getState().numberOfPlayers
}
export function setNumberOfPlayers(noOfP) {
	if (noOfP != 1 && noOfP!=2) {
		noOfP = 1 // default to singleplayers
		console.warn('defaulting to singleplayer')
	}
	manipulateState(s => s.numberOfPlayers = noOfP);
}

export function multiplayerVs_SaveScore(p1, p2) {
	manipulateState(state => state.multiplayerVs.scores.push({
		playerOne: {
			skinTone: p1.skinTone,
			count: p1.count
		},
		playerTwo: {
			skinTone: p2.skinTone,
			count: p2.count
		},
		time: Date.now()
	}));
}

export function singleplayer_SaveScore(score=0, skinTone=undefined) {
	manipulateState(s => s.singleplayer.scores.push({score: score, time: Date.now(), skinTone: skinTone}))
}
export function singleplayer_Highscore() {
	const allScores = getState().singleplayer.scores;
	if (!allScores) return undefined;
	return allScores.sort((a,b) => a.score -b.score).reverse().shift()
}

export function upgradeLocalStooorage(upgraded=[])
{
	const oldState = getState()
	if (oldState.version === GAME_VERSION) return;
	console.log('data is not up to date: ', oldState.version, ' already upgraded: ', upgraded)
	if (upgraded.find(v => v === oldState.version)) return;

	localStorage.setItem('backup', JSON.stringify(oldState))
	const script = STATE_SCRIPTS.find(v => v.oldV === oldState.version)
	if (script && script.upgrade) {
		const newState = script.upgrade(oldState)
		localStorage.setItem('jumpnrun', JSON.stringify(newState))
		upgradeLocalStooorage([...upgraded, script.oldV])
	} else {
		console.error('cant upgrade, no script found')
	}
}
export function isDebugging() {
	return (getState() && getState().debug === true)
}

const STATE_SCRIPTS = [
	{
		oldV: '1.0.0', 
		newV: '1.0.1',
		upgrade: (state) => {state.version = '1.0.1'; return state}
	},
	{
		oldV: '1.0.1', 
		newV: '1.0.2',
		upgrade: (state) => {state.version = '1.0.2'; state.features = {multiplayer: false}; return state}
	},
	{
		oldV: '1.0.2', 
		newV: '1.0.3',
		upgrade: (state) => {state.version = '1.0.3'; state.numberOfPlayers = 1; return state}
	},
	{
		oldV: '1.0.3', 
		newV: '1.0.4',
		upgrade: (state) => {state.version = '1.0.4'; state.debug = false; return state}
	},
	{
		oldV: '1.0.4', 
		newV: '1.0.5',
		upgrade: (state) => {
			if (state.scores) {
				let foo = [...state.scores];
				state.singleplayer={scores: [...foo]};
				state.scores=undefined;
			} else {
				state.singleplayer = {scores: []};
			}
			state.multiplayerVs = {scores: []};
			state.multiplayerCoop = {scores: []};
			state.version = '1.0.5';
			return state
		}
	},
	{
		oldV: '1.0.5', 
		newV: '1.0.6',
		upgrade: (state) => {
			state.version = '1.0.6';
			state.features.multiplayer = undefined
			return state
		}
	}
];